// extracted by mini-css-extract-plugin
export var currencyInput = "_lr-1";
export var currencySymbol = "_lr-0";